const message = {
  select: 'Pilih',
  calendar: 'Kalendar',
  schedule: 'Jadwal',
  works: 'Kerjaan',
  settings: 'Aturan',
  feedback: 'Saran',
  home: 'Rumah'
};
export default message;
